import { trigger, transition, style, animate } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { ApiTransactionService } from '@services/api-transaction.service';
import { SessionManager } from '@services/session-manager';
import { SharedService } from '@services/shared.service';

import { CardIssueType, Country } from '@shared/models/Enums';
import { SessionModel } from '@shared/models/SessionModel';
import { TransactionModel, TransactionNotesModel } from '@shared/models/TransactionModel';
import { VendorStoreModel } from '@shared/models/VendorModel';

import { SmartListTransactionItem } from '@components/smart-list/GenericSmartList';
/* import * as JsBarcode from 'jsbarcode'; */
import * as moment from 'moment';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-pop-details',
    templateUrl: './pop-details.component.html',
    styleUrls: ['./pop-details.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
            style({ opacity: 0 }), 
            animate('300ms ease-in', style({ opacity: 1 })) 
            ]),
            transition(':leave', [
            animate('10ms ease-out', style({ opacity: 0 })) 
            ])
        ])
    ]
})
export class PopDetailsComponent implements OnInit{

    @Input() transactionPopId: number;
    @Input() country: Country = Country.CR;
    @Input() preloadedSale: TransactionModel = null; //receive the data to dont call the api again
    @Output() preloadSale: EventEmitter<TransactionModel> = new EventEmitter<TransactionModel>(); // send the data to preload it in the next reload
    @Output() onUpdateTransactionNote: EventEmitter<TransactionNotesModel> = new EventEmitter<TransactionNotesModel>(); 

    sale: TransactionModel;
    vendorStores: VendorStoreModel[] = [];
    showSendGivi: boolean = false;

    givilink: string;
    giviLinkOrigin: string;

    linkCopied = false;
    showBarcode: boolean = false;

    token = '';
    tokenTimerId = null;

    successRedeemId = null;

    currentTokenTimerMax = 18000;
    currentTokenTimerValue = 18000;

    showSuccess = false;

    // Note
    giviNote: TransactionNotesModel;
    transactionId: number;
    customerOwnerId: number;

    now = new Date();
    nowTimerId = null;
    showDescription = false;

    issueTypes: { type: CardIssueType }[] = [];

    requireVerification = true;

    session: SessionModel;

    actionOption = 1; //1 = Qr, 2 = Barras, 3 = regalar, 4 = Download

    showMoreDetails = false;
    showAllDesc = false;

    wantToRedeem = false;
    isVisible = false;

    private wantToRedeemSubscription: Subscription = null;
    

    get giviAwaitHours(): number {

        if (this.giviAwaitMinutes > 0) {
            let hours = Math.trunc(this.giviAwaitMinutes / 60);
            return hours;
        }
        return 0;
    }

    get giviAwaitMinutes(): number {

        // Verifica si el total de la tarjeta de regalo es mayor que 30000 mil. 
        // y si debe validar la expiración de 24 horas
        if (this.sale && this.sale.giftcard && this.sale.giftcard.price > 0) {
            if (!this.sale.isExpired) {
                const now = moment(this.now.toISOString());
                const createdAt = new Date(this.sale.createdAt);
                createdAt.setHours(createdAt.getHours() + 24);
                const expiration = moment(createdAt.toISOString());

                // Calcula los minutos entre la fecha actual y la fecha de compra de la tarjeta de regalo.
                // Determinar si la tarjeta de regalo se puede canjear 
                let hours = expiration.diff(now, 'minutes');
                if (hours < 0) {
                    hours = 0;
                }
                return hours;
            }
        }
        return 0;
    }

    constructor(public location: Location,
        public router: Router, 
        public sharedService: SharedService,
        public apiTransactionService: ApiTransactionService,
        private renderer: Renderer2) {

    }

    ngOnInit(){

        this.session = this.apiTransactionService.getSession();
        if (this.session && this.session.user) {

            //hide the qr code
            this.wantToRedeemSubscription = this.sharedService.wantToRedeemId.subscribe(x => {

                if(this.sale && this.sale.id != x) {

                    clearInterval(this.tokenTimerId);
                    clearInterval(this.successRedeemId);
                    this.wantToRedeem = false;
                };
            });

            if(this.preloadedSale == null) this._getTransaction(this.transactionPopId);
            else {
            
                this.sale = new TransactionModel(this.preloadedSale);
                this._initLoad();
            }
        } else {

            this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(()=>{
                this.router.navigate(['/market']);
            });
        }
    }

    ngOnDestroy() {
        
        if (this.wantToRedeemSubscription) { this.wantToRedeemSubscription.unsubscribe(); }
        
        clearInterval(this.successRedeemId);
        clearInterval(this.nowTimerId);
        clearInterval(this.tokenTimerId);

    }

    onChangeWantToRedeem(){

        window.addEventListener('scroll', this.handleScroll);
        this.isVisible = true;

        this.sharedService.setWantToRedeemId(this.sale.id);

        this._refreshToken(); 
        this._successRedeemed();

        this.wantToRedeem = true;
    }

    handleScroll = () => {

        const targetDiv = document.querySelector('#targetDiv') as HTMLElement;

        if (targetDiv) {

            const rect = targetDiv.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {

                this.isVisible = true;
            } else this.isVisible = false;
        }
    };

    onOpen() {

        const code = `GV-${this.sale.id.toString().padStart(5, '0')}-${this.sale.customerOwnerId}`;
        let hash = window.btoa(code);

        // Remove the = symbol
        hash = hash.replace(/[=]/g, '');

        let text = `comercio=${this.sale.vendorName}`;
        // Remove the % symbol
        text = text.replace(/[%]/g, '');
        // Replace the spaces
        text = text.replace(/\s/g, '+');

        this.givilink = `${this.apiTransactionService.siteUrl}/tg/${this.session?.user?.country}/${hash}?${text}`;
        this.giviLinkOrigin = this.givilink;
        this.givilink = `${this.giviLinkOrigin}`;
    }

    verifyCard() {

        this.sharedService.setShowVerifyCardModal(this.sale);
    }

    onShowBarcode(showBarcode){

        this.showBarcode = showBarcode;

        if(showBarcode){
            setTimeout(() => {
                const barcodeElement = this.renderer.selectRootElement('#barcode', true);
                //barcode
                /* JsBarcode(barcodeElement, `${this.sale.qrCode + '/' + this.token}`, {
                    format: "CODE128",
                    lineColor: "#000",
                    width: 2,
                    height: 150,
                    displayValue: true
                }); */
            }, 10); 
        } 
    }

    onChangeOption(option){

        this.actionOption = option;

        if(option == 1) this.showBarcode = false
        if(option == 2) this.onShowBarcode(true)

    }

    onCloseSuccess() {

        //close success redeemed
        this.showSuccess = false;
        
        let url = this.router.url;
        
        this.router.navigateByUrl('/market', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(url);
        });
    }

    showGiviNote(transactionNote: TransactionNotesModel, transactionId: number, customerOwnerId: number, isExpired: boolean) {

        if (!isExpired) {
            this.giviNote = transactionNote;
            this.transactionId = transactionId;
            this.customerOwnerId = customerOwnerId;
            this.sharedService.setShowGiviNoteModalModal(true);
        }
    }

    onUpdateNote(transactionNote: TransactionNotesModel){

        this.sale.transactionNotes = transactionNote;
        this.onUpdateTransactionNote.emit(transactionNote);
    }

    private _getTransaction(id: number): void {

        this.session = this.apiTransactionService.getSession();

        let promises = [
            this._getGivis(this.session.user.id),
            this.apiTransactionService.getRecentPurchaseGiftcards()
        ];

        Promise.all(promises).then(results => {

            this.apiTransactionService.getFullTransaction(id, this.country).then(
                (transactionsResult: TransactionModel) => {

                    this.sale = transactionsResult; 
                    this._initLoad();
                }
            );
        }).catch(err => {

            let errMsg = `Error al cargar información del Givi.`;
            if (err.status == 404) {
                errMsg = `El Givi no existe.`;
            }
            // Desautorizado navigate to login
            else if (err.status == 401 || err.message?.indexOf('caducado') >= 0) {

                this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(()=>{
                        this.router.navigate(['/market']);
                    });
                return;
            }
            this.sharedService.showErrorAlert(null, errMsg).then(_x => {

                let url = this.router.url;
        
                this.router.navigateByUrl('/market', { skipLocationChange: true }).then(() => {
                    this.router.navigateByUrl(url);
                });
            });
        });
    }

    private _initLoad(){
    
        this.vendorStores = this.sale.productStores?.filter(x => x.deletedAt == null); 

        this.requireVerification = false;

        if (this.sale.giftcard) {
            
            //this._refreshCurrentTime();

            // Verificar si los givis comprados infringen algún trigger de fraude
            const myGivis = SessionManager.getMyGivis();
            if (myGivis.length == 0) {
                myGivis.push(this.sale);
            }
            const issues = this.session.verifyGiviIssues(myGivis);
            this.requireVerification = issues?.length > 0; 

            // Si se requiere verificación  y la compra fue con tarjeta
            if (this.requireVerification && this.sale.customerCard) {

                // Si la tarjeta no esta verificada y aun no tiene casos según triggers de fraude
                if (!this.sale.customerCard.verifiedAt && !this.sale.customerCard.issues?.length) {

                    // TODO: Revisar esta lógica
                    const firstIssues = issues[0];

                    // Crear caso de verificación de tarjeta
                    this.apiTransactionService.requestCardVerification(this.sale.customerCard, firstIssues.type);
                }
            }
        } 

        this.sale.country = this.country;

        this.preloadSale.emit(this.sale);

        this.onOpen();
    }

    private _refreshToken() {

        // Calcular el timer
        this.currentTokenTimerMax = 5 * 60 * 60; // 5min to Seconds

        // First token
        let tokenData = this.apiTransactionService.getToken(this.sale?.id, this.currentTokenTimerMax);
        this.currentTokenTimerValue = tokenData.currentTokenTimerValue;
        this.token = tokenData.token;

        // Refresh token each 1 second
        this.tokenTimerId = setInterval(() => {

            tokenData = this.apiTransactionService.getToken(this.sale?.id, this.currentTokenTimerMax);
            this.currentTokenTimerValue = tokenData.currentTokenTimerValue;
            this.token = tokenData.token;
        }, 100);
    }

    private async _refreshCurrentTime() {

        // First token
        this.now = await this.apiTransactionService.getServerTime();

        // Refresh token each 1 min
        this.nowTimerId = setInterval(async () => {

            this.now = await this.apiTransactionService.getServerTime();
        }, 3600);
    }

    private _successRedeemed() {

        //check if the givi has been redeemedx

        this.successRedeemId = setInterval(() => {

            if (this.sale.redeemedAt === null && this.isVisible) {

                this.apiTransactionService.getBasicTransaction(this.sale.id, this.country).then(
                    (basicTransaction) => {

                        //if the givi is actually redemeed we show a success modal 
                        //and stop de the interval
                        if (basicTransaction.redeemedAt != null) {

                            clearInterval(this.successRedeemId);

                            this.showSuccess = true;
                        }
                    }
                )
            }
        }, 1000);
    }

    private _getGivis(customerId: number): Promise<TransactionModel[]> {

        return this.apiTransactionService.getGivisByCustomerOwner(customerId)
            .then((transactionsResult: TransactionModel[]) => {

                // Filtrar solo las transacciones en que el usuario es dueño del Givi
                const availableGivis = transactionsResult.filter(x => x.customerId == customerId && x.redeemedAt == null)
                    .map(x => new SmartListTransactionItem(Object.assign({}, {
                        userId: customerId,
                        ...x
                    }))).sort((a, b) => Number(a.isExpired) - Number(b.isExpired));
                SessionManager.setMyAvailableGivis(availableGivis);

                return availableGivis;
            });
    }
    
}
